import React from 'react';
import { AppDataProvider } from '../contexts/AppDataContext';
import { MessageOperationsProvider } from '../contexts/MessageOperationsContext';
import { InputContextProvider } from '../contexts/InputContext';
import { AttachmentProvider } from '../contexts/AttachmentContext';
import { AudioProvider } from '../contexts/AudioContext';
import { SidebarProvider } from '../contexts/SideBarContext';
import { ModelContextProvider } from '../contexts/ModelContext';
import { KeyContextProvider } from '../contexts/KeyContext';

interface ChatProvidersProps {
  children: React.ReactNode;
}

export const ChatProviders: React.FC<ChatProvidersProps> = ({ children }) => {
  return (
    <AppDataProvider>
      <SidebarProvider>
        <ModelContextProvider>
          <KeyContextProvider>
            <MessageOperationsProvider>
              <AttachmentProvider>
                <InputContextProvider>
                  <AudioProvider>
                    {children}
                  </AudioProvider>
                </InputContextProvider>
              </AttachmentProvider>
            </MessageOperationsProvider>
          </KeyContextProvider>
        </ModelContextProvider>
      </SidebarProvider>
    </AppDataProvider>
  );
};